import { useAccountSummary } from "@/App/Equities/shared/services/account"
import { useIndicativeCostValue } from "@/App/Equities/shared/services/orders"
import { formatCurrency } from "@/App/Equities/shared/utils"

interface IndicativeCostProps {
  symbol: string
}

export const IndicativeCost = ({ symbol }: IndicativeCostProps) => {
  const indicativeCost: string = useIndicativeCostValue(symbol)

  return formatCurrency(indicativeCost)
}

export const PortfolioValue = () => {
  return formatCurrency(useAccountSummary().portfolioValue)
}

export const CashValue = () => {
  return formatCurrency(useAccountSummary().cash)
}
